<h2 mat-dialog-title>Clear Search History</h2>
<mat-dialog-content>
  <p>Are you sure you want to clear all entries in the search history?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    role="button"
    type="button"
    aria-label="Yes"
    mat-button
    cdkFocusInitial
    (click)="dialogRef.close('yes')"
  >
    Yes
  </button>
  <button role="button" type="button" aria-label="No" mat-button (click)="dialogRef.close('no')">
    No
  </button>
</mat-dialog-actions>
